module.exports = __webpack_public_path__ + "img/banner1_2x.44796ca1.png";